import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ClientService} from './auth/client.service';
import {environment} from '../../environments/environment';
import {
  ProductLookupPlanningDiagnosticRequest,
  ProductLookupPlanningDiagnosticResponse
} from '../models/product-lookup-diagnostic.model';

@Injectable({providedIn: 'root'})
export class ProductLookupDiagnosticsService {
  private readonly http = inject(HttpClient);
  private readonly clientService = inject(ClientService);

  planQuery(request: ProductLookupPlanningDiagnosticRequest): Observable<ProductLookupPlanningDiagnosticResponse> {
    const clientId = this.clientService.client?.id ?? '';
    return this.http.post<ProductLookupPlanningDiagnosticResponse>(
      `${environment.aiBaseServerUrl}${clientId}/product-lookup-diagnostics/plan-query`,
      request
    );
  }
}
